import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const ArrowRightLong = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 43 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M39 12H0m40 0L30.475 2M40 12l-9.525 11"
      stroke="currentColor"
      strokeWidth={4}
      fillRule="evenodd"
      strokeLinecap="square"
    />
  </svg>
)
